// src/components/MobileNav.js
import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { getMenuItems } from "../utils/menuItems";
import { useAuth } from "../context/AuthContext";

function MobileNav() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { user } = useAuth();
    const menuItems = getMenuItems(user?.role, user?.permissions);

    return (
        <div className="text-white sm:hidden bg-primary">
            <div className="flex items-center justify-between px-4 py-2">
                {/* Hamburger button */}
                <button
                    onClick={() => setIsMenuOpen(true)}
                    className="p-2 -ml-2 text-2xl rounded-md hover:bg-primary-dark"
                    aria-label="Open menu"
                >
                    <FiMenu />
                </button>

                {/* Logo or Brand */}
                <div className="text-lg font-bold">STOJALITICS</div>

                {/* Spacer to maintain centering */}
                <div className="w-8"></div>
            </div>

            {/* Overlay Panel for Menu */}
            {isMenuOpen && (
                <>
                    <div
                        className="fixed inset-0 z-40 bg-black bg-opacity-50"
                        onClick={() => setIsMenuOpen(false)}
                    />
                    <div className="fixed top-0 left-0 z-50 flex flex-col w-4/5 h-screen max-w-xs text-white bg-gray-900">
                        <div className="flex items-center justify-between p-4 bg-primary">
                            <span className="text-lg font-bold">
                                STOJALITICS
                            </span>
                            <button
                                onClick={() => setIsMenuOpen(false)}
                                className="p-2 text-2xl rounded-md hover:bg-primary-dark"
                                aria-label="Close menu"
                            >
                                <FiX />
                            </button>
                        </div>
                        <div className="flex-1 py-2 overflow-y-auto">
                            {menuItems.map((item, index) => (
                                <NavLink
                                    key={index}
                                    to={item.path}
                                    onClick={() => setIsMenuOpen(false)}
                                    className={({ isActive }) =>
                                        `flex items-center gap-4 px-4 py-3 mx-2 rounded-lg transition-all duration-200 hover:bg-gray-700 ${
                                            isActive
                                                ? "bg-primary text-white font-bold"
                                                : "text-gray-300"
                                        }`
                                    }
                                >
                                    <span className="flex items-center justify-center w-6 text-xl">
                                        {item.icon}
                                    </span>
                                    <span>{item.label}</span>
                                </NavLink>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default MobileNav;
